import { render } from "./ReportVersion7_1.vue?vue&type=template&id=13019bc7&scoped=true&ts=true"
import script from "./ReportVersion7_1.vue?vue&type=script&lang=ts"
export * from "./ReportVersion7_1.vue?vue&type=script&lang=ts"

import "./ReportVersion7_1.vue?vue&type=style&index=0&id=13019bc7&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13019bc7"]])

export default __exports__